<template>
  <div class="content">
    <div class="back" @click="backBtn">
      <i></i>
      <span>返回</span>
    </div>
    <!--搜索条件-->
    <div class="serchTerms">
      <div class="input_box">
        <span>考生姓名：</span>
        <el-input v-model.trim="accountName" placeholder="根据考生姓名或账号搜索" style="width: 200px" ></el-input>
      </div>
      <el-button
        @click="handleQuery"
        type="primary"
        icon="el-icon-search"
        class="searchbtn"
      >搜索</el-button
      >
      <el-button
        @click="resetQuery"
        icon="el-icon-refresh"
        class="searchbtn resetBtn"
      >重置</el-button
      >
    </div>

    <!-- 操作按钮 -->
    <div class="operaBtn">
      <el-button @click="handleBatchInsertStudent">
        <i class="el-icon-circle-plus-outline"></i>批量添加
      </el-button>
    </div>

    <!-- 表格内容 -->
    <sys-box-table ref="sysBoxTable"
                   :tableList="examStudentList"
                   rowKey="UserID"
                   :showIndex="true"
                   operationWidth="200px"
                   :columList="userColumList"
                   :multipleSelectionData="multipleSelectionData"
                   @handleSelectionChange="handleSelectionChange"
                   v-loading="isLoading">
      <template #slotButton="slotProps">
        <el-button icon="el-icon-circle-plus-outline" type="primary" size="medium" @click.stop="handlerInsertStudent(slotProps)">添加</el-button>
      </template>
    </sys-box-table>

    <!-- 弹框 -->
    <sys-dialog
        :title="messageDialog.title"
        :width="messageDialog.width"
        :height="messageDialog.height"
        :visible="messageDialog.visible"
        @onConfirm="messageConfirm"
        @onClose="messageClose">
      <div slot="content" class="message-text">
        <i class="iconfont icon-tishi1"></i>
        <p style="">是否确定添加考生【{{selectedName}}】参加本次考试吗！</p>
      </div>
    </sys-dialog>

    <!-- 分页 -->
    <div class="footBox">
      <div class="footPage">
        <p>
          共有{{ pageParms.total }}条记录
        </p>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageParms.currentPage"
          :page-size="pageParms.pageSize"
          :page-sizes="pageParms.pagesizesArr"
          layout="prev, pager, next, sizes, jumper"
          :total="pageParms.total"
          class="pagination">
        </el-pagination>
      </div>
    </div>


  </div>
</template>

<script>
import $monitor from "@/api/monitor.js";
import SysBoxTable from "@/components/system/SysBoxTable";
import SysDialog from "@/components/system/SysDialog";
export default {
  name: "studentExamWinding",
  components: {
    SysBoxTable,
    SysDialog
  },
  data() {
    return {
      messageDialog:{
        title:"温馨提示",
        width:440,
        height:72,
        visible:false
      },
      userColumList:[
        {
          prop: "UserName",
          lable: "考生账号",
          width:"",
          align:"center"
        },
        {
          prop: "RealName",
          lable: "考生姓名",
          width:"",
          align:"center"
        },
        {
          prop: "DepartmentName",
          lable: "科室",
          width:"",
          align:"center"
        },
        {
          prop: "PTitle",
          lable: "职称",
          width:"",
          align:"center"
        },
        {
          prop: "Position",
          lable: "职位",
          width:"",
          align:"center"
        },
        {
          prop: "Birthday",
          lable: "出生年月",
          width:"",
          align:"center",
          type:"date"
        },
        {
          prop: "JobDate",
          lable: "工作年限",
          width:"",
          align:"center",
        },
      ],
      //初始化数据被选中的
      multipleSelectionData:[],
      //被选中的用户id
      selectUserIds: [],
      selectedUserName:[],
      isLoading: false,
      accountName:"",
      // 考生列表数据
      examStudentList: [],
      pageParms:{
        // 当前页
        currentPage: 1,
        pageSize: 10,
        pagesizesArr: [5, 10, 20, 50, 100],
        // 总数量
        total: 100,
      },
      selectedRow:"",
      batchDialog:false,
      selectedName:""
    };
  },
  methods: {
    submitExamStudentList:function(parms){
      parms.examID = this.$parent.$children[0].rowData.ExamID;
      parms.PaperID = this.$parent.$children[0].rowData.PaperID;
      this.UtilFun(parms);
      $monitor.insertExamStudent(parms).then(res =>{
        let result = res.data;
        if(result.Status === 200){
          this.$message.success("添加成功！");
        }
        this.messageDialog.visible = false;
        this.$refs.sysBoxTable.handleClearSelection();
        this.getExamStudentList();
      }).catch(res =>{
        this.messageDialog.visible = false;
        this.$message.error("添加失败！");
      });
    },
    handleBatchInsertStudent:function(){
      this.batchDialog = true;
      if(this.selectUserIds.length == 0){
        this.$message.warning("请先勾选考生！");
      }else{
        this.selectedName = this.selectedUserName.toString();
        this.batchDialog = true;
        this.messageDialog.visible = true;
      }
    },
    messageConfirm:function(){
      let parms = {};
      if(this.batchDialog){
        parms.studentIDList = this.selectUserIds.toString();
      }else{
        parms.studentIDList = this.selectedRow.toString();
      }
      this.submitExamStudentList(parms);
    },
    messageClose:function(){
      this.messageDialog.visible = false;
    },
    handleSelectionChange:function(data){
      this.selectUserIds = [];
      this.selectedUserName = [];
      data.forEach(user =>{
        this.selectUserIds.push(user.UserID);
        this.selectedUserName.push(user.RealName);
      })
    },
    handlerInsertStudent:function(row){
      this.batchDialog = false;
      this.selectedRow = row.rowData.UserID;
      this.selectedName = row.rowData.RealName;
      this.messageDialog.visible = true;
    },
    getExamStudentList:async function(){
      let examID = this.$parent.$children[0].rowData.ExamID;
      this.isLoading = true;
      const parms = {};
      parms.accountName = this.accountName;
      this.UtilFun(parms);
      parms.examID = examID;
      parms.pageIndex = this.pageParms.currentPage - 1;
      parms.pageShow = this.pageParms.pageSize;
      const { data } = await $monitor.getNoExamStudent(parms);
      if (data.Status === 200) {
        this.examStudentList = data.Data.data;
        this.pageParms.total = data.Data.count;
      } else {
        this.$message.error("获取考生信息失败！");
      }
      setTimeout(() => {
        this.isLoading = false;
      }, 200);
    },
    //返回
    backBtn:function() {
      this.$parent.changes(0);
    },
    // 重置
    resetQuery:function() {
      this.accountName = "";
    },
    //查询
    handleQuery:function(){
      this.getExamStudentList();
    },
    // 显示条数
    handleSizeChange:function(val) {
      // 改变每页显示条数的时候调用一次
      this.pageParms.currentPage = 1;
      this.pageParms.pageSize = val;
      this.getExamStudentList();
      console.log(`每页 ${val} 条`);
    },
    // 分页
    handleCurrentChange:function(val) {
      console.log(`当前页: ${val}`);
      this.pageParms.currentPage = val;
      this.getExamStudentList();
    },
    // 封装方法
    UtilFun:function(paraObj) {
      paraObj.hid = parseInt(this.$store.state.hid);
      paraObj.userID = parseInt(this.$store.state.userID);
      paraObj.guid = this.$store.state.user;
      return paraObj;
    },
  },
  //被keep-alive组件包裹时使用
  activated() {
    console.log("$parent=====",this.$parent.$children[0].rowData);
    this.getExamStudentList();
  },
};
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  width: 100%;
  padding: 0px 24px !important;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
}

.back {
  border-bottom: 1px solid #f8f8f8;
  background-color: #FFF;
  width: 120px;
  padding: 10px;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}

::v-deep .el-form-item__label{
  font-size: 15px;
}

.serchTerms {
  height: 70px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  align-items: center;
  justify-content: left;
  padding-right: 20px;
  span {
    width: 75px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 21px;
    color: #333333;
    margin-right: 5px;
  }
  .searchbtn {
    margin-left: 25px;
    background: #1890ff;
    opacity: 1;
    border-radius: 4px;
  }
  .resetBtn {
    background: #ffffff;
    border: 1px solid #d9d9d9;
  }
}
.operaBtn {
  display: flex;
  margin: 14px 0px 20px 0px;
  width: 849px;
  height: 40px;
  opacity: 1;
  .el-button + .el-button {
    margin-left: 24px;
  }
  border-radius: 4px;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    letter-spacing: 1px;
    span > i {
      font-size: 14px !important;
      margin-right: 5px;
    }
  }
  .el-button:nth-child(1) {
    background: #1890ff;
    width: 114px;
  }
  .el-button:nth-child(2) {
    background: #e54d4d;
    width: 141px;
  }
}
.footBox {
  position: relative;
  height: 110px;
  .footPage {
    align-items: center;
    display: flex;
    position: absolute;
    right: 16px;
    bottom: 30px;

    span {
      line-height: 32px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      b {
        color: #ff0000;
      }
    }
  }
  .pagination {
    ::v-deep .el-pager {
      li {
        border: 1px solid #d9d9d9;
        margin-right: 8px;
        &.active {
          color: #ffffff;
          background-color: #409eff;
          border: none;
        }
      }
    }
    ::v-deep .el-pagination__jump {
      margin: 0px 10px 0px 0px !important;
    }
  }
}

.message-text{
  display: flex;
  i {
    font-size: 16px;
    color: #ffc664;
    margin-right: 10px;
    transform: translateY(4px);
  }
  p {
    text-align: left;
    font-size: 15px;
    font-weight: 400;
    line-height: 26px;
    color: #333333;
    opacity: 1;
  }
}
</style>
